export default {
	"Banner.ShopBanner": "Shop banner",
	"Banner.MarketingMallComponentClick": "Marketing Mall_Component click",
	"Banner.MarketingMarketplace": "Marketing Marketplace"
}